import { Sheba } from '../../../node_modules/@persian-tools/persian-tools'

export class Validation extends Function {
  showMessage() {
    return false
  }

  isWarning() {
    return false
  }
}

export class FieldIsRequired extends Validation {
  constructor() {
    super()
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  stopInCaseOfError() {
    return true
  }

  _call(label, value) {
    const isEmpty =
      value === '' ||
      value == null ||
      (Array.isArray(value) && value.length === 0) ||
      (typeof value === 'object' && Object.keys(value || {}).length === 0);
  
    if (isEmpty) {
      throw new Error(`${label} is required`);
    }
  }
}

export class ReportNameMustContainNonSpace extends Validation {
  constructor() {
    super()
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  showMessage() {
    return true
  }

  getMessage() {
    return 'The report name must contain at least one non-space character.'
  }

  stopInCaseOfError() {
    return false
  }

  _call(label, reportName) {
    if (!/\S/.test(reportName)) {
      throw new Error(this.getMessage())
    }
  }
}

export class ValueMoreThanX extends Validation {
  constructor(x) {
    super()
    this.x = x
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  stopInCaseOfError() {
    return false
  }

  _call(label, value) {
    if (value < this.x) throw new Error('Must be more than ' + this.x)
  }
}

export class ValueLessThanX extends Validation {
  constructor(x, decimalFormatter, priceDecimals) {
    super()
    this.x = x
    this.decimalFormatter = decimalFormatter
    this.priceDecimals = priceDecimals
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  stopInCaseOfError() {
    return false
  }

  _call(label, value) {
    if (
      this.decimalFormatter(value, this.priceDecimals) >
      this.decimalFormatter(this.x, this.priceDecimals)
    )
      throw new Error('Must be less than ' + this.decimalFormatter(this.x, this.priceDecimals))
  }
}

export class StartsWithX extends Validation {
  constructor(x) {
    super()
    this.x = x
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  stopInCaseOfError() {
    return false
  }

  _call(label, value) {
    if (value == null || value.slice(0, this.x.length) != this.x)
      throw new Error("Should start with: '" + this.x + "'")
  }
}

export class ShebaValidation extends Validation {
  constructor() {
    super()
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  stopInCaseOfError() {
    return false
  }

  _call(label, value) {
    if (value == null || !new Sheba(value).validate()) throw new Error('Invalid iban')
  }
}

export class TronWalletValidation extends Validation {
  constructor() {
    super()
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  stopInCaseOfError() {
    return false
  }

  _call(label, value) {
    if (value != null && value != '' && !/^\d+$/.test(value)) throw new Error('Only digits')
  }
}

export class OnlyDigits extends Validation {
  constructor() {
    super()
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  stopInCaseOfError() {
    return false
  }

  _call(label, value) {
    if (value != null && value != '' && !/^\d+$/.test(value)) throw new Error('Only digits')
  }
}

export class IBANOnlyDigits extends OnlyDigits {
  constructor() {
    super()
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  _call(label, value) {
    super._call(label, value.slice(2))
  }
}

export class ValueLessThanBalance extends Validation {
  constructor(balance) {
    super()
    this.balance = balance
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  stopInCaseOfError() {
    return false
  }

  _call(label, value) {
    if (value > this.balance) throw new Error('Insufficient balance')
  }
}

export class LimitBuyPriceLessThanBestBuyPrice extends Validation {
  constructor(bestBuyPrice, warningRange, errorRange, decimalFormatter, decimalPlaces, warn) {
    super()
    this.bestBuyPrice = bestBuyPrice
    this.warningRange = warningRange
    this.errorRange = errorRange
    this.decimalFormatter = decimalFormatter
    this.decimalPlaces = decimalPlaces
    this.warn = warn
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  stopInCaseOfError() {
    return !this.warn
  }

  isWarning() {
    return this.warn
  }

  _call(label, limit_buy_price) {
    let warning_limit = this.decimalFormatter(
      this.warningRange * this.bestBuyPrice,
      this.decimalPlaces
    )
    let error_limit = this.decimalFormatter(this.errorRange * this.bestBuyPrice, this.decimalPlaces)
    if (limit_buy_price > Number(error_limit)) {
      if (!this.warn)
        throw new Error(
          'Is too much more than best buy price: ' +
          this.decimalFormatter(this.bestBuyPrice, this.decimalPlaces)
        )
    } else if (limit_buy_price > Number(warning_limit)) {
      if (this.warn)
        throw new Error(
          'Is too much more than best buy price: ' +
          this.decimalFormatter(this.bestBuyPrice, this.decimalPlaces)
        )
    }
  }
}

export class LimitSellPriceMoreThanBestSellPrice extends Validation {
  constructor(bestSellPrice, warningRange, errorRange, decimalFormatter, decimalPlaces, warn) {
    super()
    this.bestSellPrice = bestSellPrice
    this.warningRange = warningRange
    this.errorRange = errorRange
    this.decimalFormatter = decimalFormatter
    this.decimalPlaces = decimalPlaces
    this.warn = warn
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  stopInCaseOfError() {
    return !this.warn
  }

  isWarning() {
    return this.warn
  }

  _call(label, limit_buy_price) {
    let warning_limit = this.decimalFormatter(
      this.warningRange * this.bestSellPrice,
      this.decimalPlaces
    )
    let error_limit = this.decimalFormatter(
      this.errorRange * this.bestSellPrice,
      this.decimalPlaces
    )
    if (limit_buy_price < Number(error_limit)) {
      if (!this.warn)
        throw new Error(
          'Is too much less than best sell price: ' +
          this.decimalFormatter(this.bestSellPrice, this.decimalPlaces)
        )
    } else if (limit_buy_price < Number(warning_limit)) {
      if (this.warn)
        throw new Error(
          'Is too much less than best sell price: ' +
          this.decimalFormatter(this.bestSellPrice, this.decimalPlaces)
        )
    }
  }
}

export class PasswordLength extends Validation {
  constructor(minimum_length) {
    super()
    this.minimum_length = minimum_length
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  showMessage() {
    return true
  }

  getMessage() {
    return 'Must be at least ' + this.minimum_length + ' characters'
  }

  stopInCaseOfError() {
    return false
  }

  _call(label, password) {
    if (password.length < this.minimum_length) throw new Error(this.getMessage())
  }
}

export class PasswordMustContainsAtleastOneNumericCharacter extends Validation {
  constructor() {
    super()
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  showMessage() {
    return true
  }

  getMessage() {
    return 'Must contains atleast one digit. (1..9)'
  }

  stopInCaseOfError() {
    return false
  }

  _call(label, password) {
    if (!/\d/.test(password)) throw new Error(this.getMessage())
  }
}

export class PasswordMustContainsAtleastOneSign extends Validation {
  constructor() {
    super()
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  showMessage() {
    return true
  }

  getMessage() {
    return 'Must contains atleast one sign. (!@#$%&*_)'
  }

  stopInCaseOfError() {
    return false
  }

  _call(label, password) {
    if (!/[\!\@\#\$\%\&\*\_]/.test(password)) throw new Error(this.getMessage())
  }
}

export class PasswordMustContainsAtleastOneUpperCase extends Validation {
  constructor() {
    super()
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  showMessage() {
    return true
  }

  getMessage() {
    return 'Must contains atleast one uppercase letter. (A-Z)'
  }

  stopInCaseOfError() {
    return false
  }

  _call(label, password) {
    if (!/[A-Z]/.test(password)) throw new Error(this.getMessage())
  }
}

export class PasswordMustContainsAtleastOnelowerCase extends Validation {
  constructor() {
    super()
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  showMessage() {
    return true
  }

  getMessage() {
    return 'Must contains at least one lowercase letter. (a-z)'
  }

  stopInCaseOfError() {
    return false
  }

  _call(label, password) {
    if (!/[a-z]/.test(password)) throw new Error(this.getMessage())
  }
}

export class ConfirmPasswordMustMatchPassword extends Validation {
  constructor(getPasswordFunc) {
    super()
    this.getPasswordFunc = getPasswordFunc
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  getMessage() {
    return 'Password and confirm password doest no match'
  }

  stopInCaseOfError() {
    return false
  }

  _call(label, confirmPassword) {
    if (confirmPassword !== this.getPasswordFunc()) throw new Error(this.getMessage())
  }
}

export class AllowedCountry extends Validation {
  constructor(allowedCountrySymbols) {
    super()
    this.allowedCountrySymbols = allowedCountrySymbols
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  getMessage() {
    return 'Country is not allowed'
  }

  stopInCaseOfError() {
    return false
  }

  _call(label, phoneNumber) {
    let countryCode = phoneNumber.slice(phoneNumber.indexOf('(') + 1, phoneNumber.indexOf(')'))
    if (!this.allowedCountrySymbols.includes(countryCode)) throw new Error(this.getMessage())
  }
}

export class DestinationWalletAddressIsValid extends Validation {
  constructor(regexPattern) {
    super()
    this.regexPattern = regexPattern
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  stopInCaseOfError() {
    return false
  }

  _call(label, value) {
    if (value == null || !this.regexPattern.test(value))
      throw new Error('Invalid wallet address format for the selected network.')
  }
}

export class EmailValidation extends Validation {
  constructor() {
    super()
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  getMessage() {
    return 'Invalid email address format.'
  }

  stopInCaseOfError() {
    return false
  }

  _call(label, email) {
    // Basic regex for email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailPattern.test(email)) {
      throw new Error(this.getMessage())
    }
  }
}

export class PhoneNumberValidation extends Validation {
  constructor() {
    super()
    return new Proxy(this, {
      apply: (target, thisArg, args) => target._call(...args)
    })
  }

  getMessage() {
    return 'Invalid phone number format.'
  }

  stopInCaseOfError() {
    return false
  }

  _call(label, phoneNumber) {
    const strippedPhoneNumber = phoneNumber.replace(/^\(\+\d{1,4}\)\s*/, '');
    if (!strippedPhoneNumber || !/\d/.test(strippedPhoneNumber)) {
      return;
    }
    const phoneNumberPattern = /^\(\+\d{1,4}\)\s?\d{4,14}$/;
    if (!phoneNumberPattern.test(phoneNumber)) {
      throw new Error(this.getMessage())
    }
  }
}
